// src/pages/organizations.js
'use client';
import React, { useState, useEffect } from 'react';
import EditOrgModal from '../components/Modals/EditOrgModal';

const Organizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [orgName, setOrgName] = useState('');
  const [orgDescription, setOrgDescription] = useState('');
  const [No_Forms, setNo_Forms] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentOrg, setCurrentOrg] = useState(null);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [orgToDelete, setOrgToDelete] = useState(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    checkUserRole();
    fetchOrganizations();
  }, []);

  const checkUserRole = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        process.env.REACT_APP_URL_BASE_BACKEND + '/api/user/profile',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const userData = await response.json();
      setIsAdmin(userData.rol === 'Admin');
    } catch (error) {
      console.error('Error al verificar rol de usuario', error);
    }
  };

  const fetchOrganizations = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        process.env.REACT_APP_URL_BASE_BACKEND + '/organizations',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setOrganizations(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error al obtener organizaciones', error);
    }
  };

  const handleSubmitOrganization = async e => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        process.env.REACT_APP_URL_BASE_BACKEND + '/organizations',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name: orgName,
            description: orgDescription,
            No_Forms,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.error || 'Error al agregar organización');
        return;
      }

      const newOrganization = await response.json();
      setOrganizations([...organizations, newOrganization]);
      setOrgName('');
      setOrgDescription('');
      setNo_Forms('');
      document.getElementById('org_modal').close();

      // Mostrar alerta de éxito
      setSuccessMessage('Organización creada con éxito');
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 3000);
    } catch (error) {
      console.error('Error al crear la organización', error);
    }
  };

  const handleDeleteOrganization = async orgId => {
    const org = organizations.find(org => org._id === orgId);
    if (!org) return;

    setOrgToDelete(org);
    setShowDeleteAlert(true);
  };

  const confirmDelete = async () => {
    if (!orgToDelete) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        process.env.REACT_APP_URL_BASE_BACKEND +
          `/organizations/${orgToDelete._id}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.error);
        return;
      }

      setShowDeleteAlert(false);
      setSuccessMessage('Organización eliminada con éxito');
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 3000);
      fetchOrganizations();
    } catch (error) {
      console.error('Error eliminando la organización:', error);
    }
  };

  const cancelDelete = () => {
    setShowDeleteAlert(false);
    setOrgToDelete(null);
  };

  const handleSaveOrg = async editedOrg => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        process.env.REACT_APP_URL_BASE_BACKEND +
          `/organizations/${editedOrg._id}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(editedOrg),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.error || 'Error al actualizar la organización');
        return;
      }

      const updatedOrg = await response.json();
      setOrganizations(
        organizations.map(org =>
          org._id === updatedOrg._id ? updatedOrg : org
        )
      );
      document.getElementById('edit_modal').close();
      alert('Organización actualizada con éxito');
    } catch (error) {
      console.error('Error al actualizar la organización', error);
    }
  };

  return (
    <div className="relative min-h-screen">
      <div className="absolute top-20 right-4 z-50 space-y-4">
        {showDeleteAlert && orgToDelete && (
          <div
            role="alert"
            className="alert alert-vertical sm:alert-horizontal shadow-lg"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="stroke-info h-6 w-6 shrink-0"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span>
              ¿Está seguro de eliminar la organización "{orgToDelete.name}"?
            </span>
            <div className="flex gap-2">
              <button className="btn btn-sm" onClick={cancelDelete}>
                Cancelar
              </button>
              <button
                className="btn btn-sm btn-primary"
                onClick={confirmDelete}
              >
                Confirmar
              </button>
            </div>
          </div>
        )}

        {showSuccessAlert && (
          <div role="alert" className="alert alert-success shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 shrink-0 stroke-current"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>{successMessage}</span>
          </div>
        )}
      </div>

      <div className="container mx-auto px-4 pt-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl">Lista de Organizaciones</h2>
          {isAdmin && (
            <button
              className="btn btn-accent btn-outline rounded-full ml-auto"
              onClick={() => document.getElementById('org_modal').showModal()}
            >
              Agregar Organización
            </button>
          )}
        </div>

        {isAdmin && (
          <dialog id="org_modal" className="modal">
            <div className="modal-box">
              <h3 className="font-bold text-lg">Creación de Organización</h3>
              <form onSubmit={handleSubmitOrganization}>
                <br />
                <label className="input input-bordered flex items-center gap-2">
                  <input
                    type="text"
                    className="grow"
                    value={orgName}
                    onChange={e => setOrgName(e.target.value)}
                    placeholder="Nombre de la Organización"
                    required
                  />
                </label>
                <br />
                <label className="input input-bordered flex items-center gap-2">
                  <input
                    type="text"
                    className="grow"
                    value={orgDescription}
                    onChange={e => setOrgDescription(e.target.value)}
                    placeholder="Descripción"
                    required
                  />
                </label>
                <br />
                <select
                  className="select select-bordered w-full max-w-xs"
                  value={No_Forms}
                  onChange={e => setNo_Forms(e.target.value)}
                  required
                >
                  <option value="">Seleccione un limite de Formularios</option>
                  <option value="10">De 1 a 10</option>
                  <option value="20">De 1 a 20</option>
                  <option value="30">De 1 a 30</option>
                  <option value="40">De 1 a 40</option>
                  <option value="50">De 1 a 50</option>
                  <option value="60">De 1 a 60</option>
                  <option value="70">De 1 a 70</option>
                  <option value="80">De 1 a 80</option>
                  <option value="90">De 1 a 90</option>
                  <option value="100">De 1 a 100</option>
                </select>
                <br />
                <br />
                <button
                  type="submit"
                  className="btn btn-accent btn-outline rounded-full"
                >
                  Crear Organización
                </button>
              </form>
              <div className="modal-action">
                <form method="dialog">
                  <button className="btn btn-error btn-outline rounded-full">
                    Cerrar
                  </button>
                </form>
              </div>
            </div>
          </dialog>
        )}

        <div className="overflow-x-auto">
          <table className="table">
            {/*Cabeza*/}
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Numero de Formularios</th>
                {isAdmin && <th>Acciones</th>}
              </tr>
            </thead>
            <tbody>
              {organizations.map(org => (
                <tr key={org._id}>
                  <th>{org.name}</th>
                  <td>{org.description}</td>
                  <td>{org.No_Forms}</td>
                  {isAdmin && (
                    <>
                      <td>
                        <button
                          className="btn btn-error btn-outline rounded-full"
                          onClick={() => handleDeleteOrganization(org._id)}
                        >
                          Eliminar
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn btn-accent btn-outline rounded-full"
                          onClick={() => {
                            setCurrentOrg(org);
                            document.getElementById('edit_modal').showModal();
                          }}
                        >
                          Editar
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />

        <EditOrgModal
          org={currentOrg}
          onSave={handleSaveOrg}
          onClose={() => document.getElementById('edit_modal').close()}
          organizations={organizations}
          isAdmin={isAdmin}
          allowPasswordChange={true}
        />
      </div>
    </div>
  );
};

export default Organizations;